
(function(){
  function closest(el, sel){ return el && (el.matches ? el.closest(sel) : null); }
  function openModal(){
    var modal = document.querySelector('[data-czh-modal]');
    if(!modal) return;
    modal.hidden = false;
    modal.classList.add('czh-open');
    document.documentElement.classList.add('czh-modal-active');
  }
  function closeModal(){
    var modal = document.querySelector('[data-czh-modal]');
    if(!modal) return;
    modal.classList.remove('czh-open');
    modal.hidden = true;
    document.documentElement.classList.remove('czh-modal-active');
  }
  function updateCountdown(root){
    var launchText = root.getAttribute('data-czh-launch');
    if(!launchText) return;
    var launch = new Date(launchText).getTime();
    if(isNaN(launch)) return;
    var diff = launch - Date.now();
    var vals = {days:'00',hours:'00',mins:'00',secs:'00'};
    if(diff > 0){
      vals.days = String(Math.floor(diff/864e5)).padStart(2,'0');
      vals.hours = String(Math.floor((diff%864e5)/36e5)).padStart(2,'0');
      vals.mins = String(Math.floor((diff%36e5)/6e4)).padStart(2,'0');
      vals.secs = String(Math.floor((diff%6e4)/1e3)).padStart(2,'0');
    }
    Object.keys(vals).forEach(function(k){
      var el = root.querySelector('[data-czh-cd-'+k+']');
      if(el) el.textContent = vals[k];
    });
  }
  function initCountdowns(){
    document.querySelectorAll('[data-czh-countdown]').forEach(function(root){ updateCountdown(root); });
  }
  document.addEventListener('click', function(e){
    if(closest(e.target, '[data-czh-open-modal]')){ e.preventDefault(); openModal(); }
    if(closest(e.target, '[data-czh-close-modal]')){ e.preventDefault(); closeModal(); }
    var modal = document.querySelector('[data-czh-modal]');
    if(modal && e.target === modal){ closeModal(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeModal(); });
  function initReveal(){
    var els = document.querySelectorAll('.czh-reveal');
    if(!('IntersectionObserver' in window)){ els.forEach(function(el){el.classList.add('czh-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){ if(entry.isIntersecting){ entry.target.classList.add('czh-visible'); obs.unobserve(entry.target); } });
    }, {threshold:0.1});
    els.forEach(function(el){obs.observe(el);});
  }
  document.addEventListener('DOMContentLoaded', function(){ initReveal(); initCountdowns(); setInterval(initCountdowns, 1000); });
  document.addEventListener('shopify:section:load', function(){ initReveal(); initCountdowns(); });
})();
